export class SendingStatus {
    httpError: boolean;
    instanceFailure: boolean;
    sent: boolean;

    constructor(httpError: boolean, instanceFailure: boolean, sent: boolean) {
        this.httpError = httpError;
        this.instanceFailure = instanceFailure;
        this.sent = sent;
    }
}
